// extracted by mini-css-extract-plugin
export default {"results":"results___Nxcq7","tips":"tips___hGELg","btns":"btns___uuuRI"};